import React from 'react';

export default function DemoMessage(props) {
    return (
        <div className="demo_message_container">
            <div className="demo_message_content">
                <div
                    className="demoCloseBut"
                    onClick={() => {
                        props.setDemoMessage({disp: false});
                        props.setDuration('');
                        props.setServiceType('');
                        props.setBookPseudo('');
                        }}>
                    <img
                      src={process.env.PUBLIC_URL + '/icons/go_back_70x70.ico'}
                      width="50"
                      height="50"
                      alt="go back" />
                </div>
                <div className="demo_message_title">
                    <h4 style={{margin: '0', marginTop: '20px', padding: '0'}}>
                        {props.demoMessage.title}
                    </h4>
                </div>
                <div className="demo_message_message">
                    <p style={{margin: '0', padding: '0'}}>
                        {props.demoMessage.message}
                    </p>
                    <p style={{margin: '0', padding: '0 15px'}}>
                        In the real version, the customer receives a confirmation email
                    </p>
                </div>
                    <p style={{margin: '0', padding: '0'}}>
                        <span style={{fontSize: '16px'}}>
                            Your name reservation : 
                        </span>
                        <span style={{fontSize: '20px', color: '#15288F', fontWeight: '700'}}>
                            {'\t' + props.demoMessage.name}
                        </span>
                    </p>
                <p style={{margin: '0', padding: '0'}}>
                    <span style={{fontSize: '16px'}}>Duration :  </span>
                    <span style={{fontSize: '20px', color: '#15288F', fontWeight: '700'}}>
                        {props.duration}
                    </span>
                    <span> h</span>
                    <span>{'\t - \t'}</span>
                    <span style={{fontSize: '16px'}}>
                        Type of service : 
                    </span>
                    <span style={{fontSize: '20px', color: '#15288F', fontWeight: '700'}}>
                        {'\t' + props.serviceType}
                    </span>
                </p>
            </div>
        </div>
    )
}
